document.addEventListener("DOMContentLoaded", function () {

    // search
    const searchOpenButton = document.querySelector('.es-header__icon--search');
    const searchCloseButton = document.querySelector('.es-search-form-close');

    searchOpenButton.addEventListener("click", function () {
        this.classList.add('open');
    });
    searchCloseButton.addEventListener('click', function () {
        searchOpenButton.classList.remove('open');
    })

    // menu
    var menuItems = document.querySelectorAll(".mt-header .mt-mega-menu-item summary");
    var menuContents = document.querySelectorAll(".mt-header .mega-menu__content");

    menuItems.forEach(item => {
        item.addEventListener("mouseover", function () {
            this.closest("details").setAttribute("open", "");
        });

        item.addEventListener("mouseleave", function () {
            this.closest("details").removeAttribute("open");
        });
    });

    menuContents.forEach(content => {
        content.addEventListener("mouseover", function () {
            this.closest("details").setAttribute("open", "");
        });

        content.addEventListener("mouseleave", function () {
            this.closest("details").removeAttribute("open");
        });
    });

    const drawerMenus = document.querySelectorAll("summary.menu-drawer__menu-item");
    const drawerCloseBtns = document.querySelectorAll(".menu-drawer__submenu .menu-drawer__close-button");
    const container = document.querySelector("#menu-drawer");
    const toggle = document.querySelector('header-drawer summary');
    if (drawerMenus.length > 0 && drawerCloseBtns.length > 0 && container && toggle) {
        drawerMenus.forEach(item => {
            item.addEventListener("click", function () {
                const subContainer = this.nextElementSibling.querySelector(".mt-menu-drawer__sub_container");
                if (subContainer) {
                    container.style.height = subContainer.clientHeight + 70 + "px";
                }
            });
        });

        drawerCloseBtns.forEach(btn => {
            btn.addEventListener("click", function () {
                container.style.height = "auto";
            });
        });

        toggle.addEventListener('click', () => {
            container.style.height = "auto";
        })
    }

});

class StickyHeader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.header = document.getElementById('shopify-section-header');
        this.headerBounds = {};
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
        this.setHeightAttribute();
        window.addEventListener('resize', this.setAttribute.bind(this));
    }

    disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const headerContent = document.querySelector("sticky-header");

        if (scrollTop > (headerContent.clientHeight + 25)) {
            headerContent.classList.add("is-scroll-active");
        } else {
            headerContent.classList.remove("is-scroll-active");
        }

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (!this.preventReveal) {
                requestAnimationFrame(this.reveal.bind(this));
            } else {
                window.clearTimeout(this.isScrolling);

                this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                }, 66);

                requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
    }

    hide() {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
    }

    reveal() {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
    }

    setHeightAttribute() {
        document.body.style.setProperty('--header-height', this.clientHeight + 'px');
    }
}

customElements.define('sticky-header', StickyHeader);